<template>
  <div :class="containerClassName">
    <slot name="label" :id="id" :label="label" :required="required">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>

    <div class="input-container" :class="inputContainerClasses" :data-symbol="symbol">
      <textarea
        :id="id"
        :name="name"
        :value="value"
        :class="inputClasses"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :rows="rows"
        ref="me"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
      ></textarea>
      <span v-if="disabled || readonly" class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{errors.first(name)}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheTextInput',
  inject: [
    '$validator'
  ],
  props: {
    label: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    autoResize: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    symbol: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 10
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      // Add autoresize
      if (this.autoResize) {
        cls.push('no-resize')
      }

      // Add error
      if (this.errors.has(this.name)) {
        cls.push('error')
      }

      return cls
    },
    inputContainerClasses: function () {
      let cls = []

      if (this.errors.has(this.name)) {
        cls.push('form-error')
      }

      if (this.disabled) {
        cls.push('disabled')
      }

      cls.push('input-lockable-test')

      return cls
    }
  },
  updated () {
    this.resize()
  },
  mounted () {
    this.resize()
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)

      if (this.autoResize && event.target && event.target.style) {
        event.target.style.height = 'auto'
        event.target.style.height = `${(event.target.scrollHeight + 2)}px`
      }
    },
    onBlur (event) {
      this.$emit('blur')
    },
    onFocus (event) {
      this.$emit('focus')
    },
    resize () {
      if (this.autoResize) {
        const vm = this
        setTimeout(() => {
          if (vm.$refs && vm.$refs.me && vm.$refs.me.style) {
            vm.$refs.me.style.height = 'auto'
            vm.$refs.me.style.height = `${vm.$refs.me.scrollHeight + 2}px`
          }
        })
      }
    }
  }
}
</script>
<style scoped>
  .no-resize {
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Inputs/TheTextArea.vue